import React from "react";
import SectionHeading from "./SectionHeading";
import { SKILL_GROUPS } from "./data/content";
import { useIntersectionObserver } from "./useIntersectionObserver";

function Skills() {
  const ref = React.useRef(null);
  const [inView] = useIntersectionObserver(ref);

  return (
    <section
      id="skills"
      className={"site-section site-section--alt" + (inView ? " section-is-visible" : "")}
      ref={ref}
    >
      <div className="section-inner">
        <SectionHeading
          label="Skills"
          title="Tools I work with"
          description="Technologies I've used on the job and in projects."
        />

        <div className="skills-grid">
          {SKILL_GROUPS.map((group, index) => (
            <article
              key={group.title}
              className="skills-group glass-card reveal-item"
              style={{ "--item-index": index }}
            >
              <h3 className="skills-group-title">{group.title}</h3>
              <ul className="skills-list">
                {group.skills.map((skill) => (
                  <li key={skill} className="skill-pill">
                    {skill}
                  </li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Skills;
